"use client";
import { useTranslations } from "next-intl";
import React, { useCallback } from "react";
import { useForm } from "react-hook-form";
import useSendContactForm from "../../layout/hooks/useSendContactForm";
import { Form, FormField, Input, Textarea } from "../../theme/components/Form";
import useFormValidators from "../../theme/hooks/useFormValidators";
import FormErrors from "../../theme/components/FormErrors";

const ContactForm = () => {
  const t = useTranslations();
  const { sendContactForm, called, error } = useSendContactForm("MESSAGE");
  const { required, validateMaxLength, validateEmail, validatePhoneNumber } =
    useFormValidators();

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      company: null,
      full_name: null,
      phoneNumber: null,
      email: null,
      message: "",
    },
  });

  const onSubmit = useCallback(
    async ({ company, full_name, phoneNumber, email, message }) => {
      try {
        await sendContactForm({
          message,
          topic: `Feedback zum Beta MyPublicare Portal von ${phoneNumber}`,
          fullName: full_name,
          company,
          emailAddress: email,
        });
      } catch (error: any) {
        const { message, graphQLErrors } = error || {};
        const [gqlError] = graphQLErrors || [];

        if (
          gqlError.message?.includes("auth failed") ||
          message?.includes("auth failed")
        ) {
          setError("email", {
            message: t("error_send_contact_form"),
          });
        }
      }
    },
    [sendContactForm],
  );

  if (called && !error) {
    return <div className="container">{t.rich("contact_thanks")}</div>;
  }

  return (
    <Form
      onSubmit={handleSubmit(onSubmit)}
      className="container container-narrow my-5 d-print-none"
    >
      <div className="row">
        <FormField
          type="text"
          label={t("full_name")}
          className="col-6 mb-3"
          {...register("full_name", {
            required,
            validate: validateMaxLength(30),
          })}
          errorMessage={errors?.full_name?.message}
        />
        <FormField
          type="text"
          label={t("company")}
          className="col-6 mb-3"
          errorMessage={errors?.company?.message}
          {...register("company")}
        />
      </div>
      <div className="row">
        <FormField
          type="email"
          {...register("email", { required, validate: validateEmail })}
          errorMessage={errors?.email?.message}
          label={t("email")}
          className="col-6 mb-3"
        />
        <FormField
          type="text"
          label={t("telephoneNumber")}
          {...register("phoneNumber", {
            validate: (value) => (!value ? true : validatePhoneNumber(value)),
          })}
          className="col-6 mb-3"
        />
      </div>

      <div className="row">
        <FormField
          rows={5}
          InputField={Textarea}
          className="w-100"
          label={t("content")}
          errorMessage={errors?.message?.message}
          {...register("message", { required })}
        />
      </div>
      <FormErrors errors={errors} />

      <Input type="submit" className="mt-3" value={t("submit")} />
    </Form>
  );
};

export default ContactForm;
